import React from 'react';
import { Redirect, useParams } from 'react-router-dom';

// Pages
import LoginPage from 'pages/root/LoginPage';
import PropTypes from 'prop-types';

import { usePermissions, useSeller, useUser } from 'hooks';
import { sessionToken } from 'utils';

import BootGate from '../BootProvider/BootGate';

// Components

function SellerGuard({ children }) {
  // Custom hooks
  const { isAuthenticated } = useUser();
  const { permissions } = usePermissions();
  const { sellerSlug } = useParams();
  const { error, sellerPermissions } = useSeller();

  // Constants
  const { isSeller, isStaff } = permissions;
  const { token } = sessionToken();

  if (!isAuthenticated && !token) return <LoginPage />;

  if (!isStaff && !isSeller) return <Redirect to="/not-authorized" />;

  if (sellerSlug && !sellerPermissions && !error) return <BootGate />;

  if (error) return <Redirect to="/not-authorized" />;

  return children;
}

SellerGuard.propTypes = {
  children: PropTypes.any,
};

export default SellerGuard;
